import React from 'react';
import { Hero } from '../components/home/Hero';
import { Methodes } from '../components/home/Methodes';
import { APropos } from '../components/home/APropos';
import { Formats } from '../components/home/Formats';
import { Temoignage } from '../components/home/Temoignage';
import { ContactCTA } from '../components/home/ContactCTA';
export function Home() {
  return <>
      <Hero data-id="element-172" data-mp="1zhxkccfqsoyu" />
      <Methodes data-id="element-173" data-mp="1zi7bi3cix264" />
      <APropos data-id="element-174" data-mp="1ziqwjsxh06od" />
      <Formats data-id="element-175" data-mp="1zj8xv3yzpb35" />
      <Temoignage data-id="element-176" data-mp="1zjs6tv6nwp51" />
      <ContactCTA data-id="element-177" data-mp="1zkaa3brqs3mg" />
    </>;
}